import {FunnelChart} from '@crema/modules/thirdParty';
export default FunnelChart;
